import React from 'react';
import Cite from './Cite';
import TextOnly from './TextOnly';
import TwoColumns from './TwoColumns';
import WithHashTags from './WithHashTags';
import Highlighted from './Highlighted';
import ModelService from '../../../../services/projectSections.service';

const ProjectSectionViewContainer = ({
  viewType,
  ...props
}) => {

    switch(Number(viewType)) {
        case ModelService.TYPE_TEXT_ONLY:
            return <TextOnly {...props}/>
        case ModelService.TYPE_WITH_HASHTAGS:
            return <WithHashTags {...props}/>
        case ModelService.TYPE_TWO_COLUMNS:
            return <TwoColumns {...props}/>
        case ModelService.TYPE_HIGHLIGHTED:
            return <Highlighted {...props}/>
        case ModelService.TYPE_QUOTE:
            return <Cite {...props}/>
        default: 
            return <TextOnly {...props}/>
    }
}

export default ProjectSectionViewContainer;



// WEBPACK FOOTER //
// ./src/views/projects/project-section/components/ProjectSectionViewContainer.jsx